export const DEFAULT_FILTERS = {
  keyword: '',
  places: null,
  topicIds: [],
  ocpStatus: null,
  missingManager: null,
  qa: undefined,
  page: 1,
};
